import Direction from "views/logic/aggregationbuilder/Direction";
export default class MessageSortConfig {
  constructor(field, direction) {
    this._value = { field, direction };
  }
  toJSON() {
    const { field, direction } = this._value;
    return {
      field,
      order: direction === Direction.Ascending ? "ASC" : "DESC"
    };
  }
  static fromJSON({ field, order }) {
    const direction = Direction.fromJSON(order === "ASC" ? "Ascending" : "Descending");
    return new MessageSortConfig(field, direction);
  }
}
